<form nz-form [formGroup]="form">
  <nz-table formArrayName="details" [nzData]="data" [nzFrontPagination]="false" [nzShowPagination]="false"
    nzBordered="true" nzSize="small" style="overflow-x: auto; max-height: 355px;">
    <thead>
      <tr>
        <th nzWidth="120px" [nzAlign]="'center'">
          WTax Code
        </th>
        <th nzWidth="120px" [nzAlign]="'right'">
          Payment Amount
        </th>
        <th nzWidth="120px" [nzAlign]="'right'">
          WTax
        </th>
        <th nzWidth="100px">
        </th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let line of details.controls; let i = index" [formGroupName]="i">
        <td>
          <app-input-wtax-code-select formControlName="wTaxCode" valueField="" [borderless]="true">
          </app-input-wtax-code-select>
        </td>
        <td class="text-right">
          <app-currency-input formControlName="paymentAmount" [ignoreZero]="true" [borderless]="true">
          </app-currency-input>
        </td>
        <td class="text-right">
          {{$any(line.value.wTaxAmount)|price}}
        </td>
        <td [acl]="aclWtaxLineColumns" class="text-right">
          <div class="text-center">
            <button type="button" nz-button nzType="text" (click)="removeLine(i)">
              <span nz-icon nzType="delete" nzTheme="outline"></span>
            </button>
          </div>
        </td>
      </tr>
      <tr>
        <td colSpan="4">
          <button type="button" nz-button [nzType]="'dashed'" (click)="addLine()" nzBlock class="mt-md">
            <i nz-icon nzType="plus"></i>
            <span>New Line</span>
          </button>
        </td>
      </tr>
    </tbody>
  </nz-table>
</form>
